module.exports = __webpack_public_path__ + "static/media/52_B.c085ad2d.png";